import { Component, OnInit } from "@angular/core";

import { encryptStorage } from "../../utils/storage/storage";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  username: string = "";

  constructor() {}

  ngOnInit() {
    this.username = encryptStorage.getItem("@user", false);
  }
}
